// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notice-text {
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
  font-family: var(--font-secondary);
}
.notice-text.success {
  color: var(--ion-color-success);
}

.map-container {
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  min-height: 250px;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/delivery-area-location-modal/delivery-area-location-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;AACF;AACE;EACE,+BAAA;AACJ;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAAF","sourcesContent":[".notice-text {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 16px;\n  font-family: var(--font-secondary);\n\n  &.success {\n    color: var(--ion-color-success);\n  }\n}\n\n.map-container {\n  position: relative;\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 250px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
